<template>
  <div class="ccs-layout">
    <div class="ccs-12 ccs-layout ccs-layout--no-pad">
      <ccs-input class="ccs-12" v-model.trim="fieldsValues.name" v-bind="fieldsDefinitions.name"
        @error="(err) => setFieldError('name', err)"/>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div>
        <button class="ccs-button" @click="submit">
          Сохранить изменения
        </button>
      </div>
      <div>
        <button class="ccs-button ccs-button--light" @click="$emit('close')">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import FormHelper from '@/mixins/FormHelper.js';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'EventType',
  mixins: [FormHelper],
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      fieldsDefinitions: {
        name: {
          isValid: false,
          error: '',
          required: true,
          type: "text",
          label: "Название",
          placeholder: "Введите название",
        },
      },
      fieldsValues: {
        name: '',
      },
    };
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return undefined;
      },
    },
  },
  computed: {
    isEditing() {
      return !!(this.$props.data && this.$props.data.id);
    }
  },
  methods: {
    ...mapActions('events', ['createEventType', 'updateEventType']),
    async submit() {
      this.validateForm();
      if (this.isFormValid) {
        if (this.fieldsValues.id) {
          this.editEventType();
        } else {
          this.addEventType();
        }
      }
    },
    async addEventType() {
      try {
        await this.createEventType(this.fieldsValues);
        this.$toasted.success('Тип мероприятия добавлен');
        this.$emit('close');
      } catch (err) {
        this.showServerValidationErrors(err);
      }
    },
    async editEventType() {
      try {
        await this.updateEventType(this.fieldsValues);
        this.$toasted.success('Тип мероприятия изменен');
        this.$emit('close');
      } catch (err) {
        this.showServerValidationErrors(err);
      }
    },
  },
  mounted() {
    if (this.$props.data && this.$props.data.id) {
      this.fieldsValues = this.$props.data;
    }
  },
}
</script>

<style>
.button--add {
  margin-top: 22px;
}
</style>